import { toast } from "react-toastify";

const notify = (msg, typeMsg) => {
  const toastConfig = {
    position: "top-right",
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    toastId: msg, // Prevent duplicate toasts with the same message
  };

  typeMsg === "success"
    ? toast.success(msg, toastConfig)
    : typeMsg === "error"
    ? toast.error(msg, toastConfig)
    : toast.info(msg, {
        ...toastConfig,
        bodyClassName: "text-xl",
        className: "text-class",
      });
};
export default notify;
